import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import defaultUserPhoto from '../../../images/default_user.png';
import { timeFormatUi, dayMonthShort, dayMonthDate } from '../../../constants/date';
import { appPath } from '../../../constants';
import UsersService from '../../../services/UsersService';
import { renderDateWithTimeZone } from '../../../helpers/timezones';

export default class ConversationsListItem extends Component {
  static propTypes = {
    conversation: PropTypes.object.isRequired,
    isActive: PropTypes.bool,
    addAdminLastMessageToList: PropTypes.func.isRequired,
    updateConversationMessagesCount: PropTypes.func.isRequired,
    selectConversationChat: PropTypes.func.isRequired
  };

  componentDidMount () {
    window.addAdminLastMessageToList = this.props.addAdminLastMessageToList;
    window.updateConversationMessagesCount = this.props.updateConversationMessagesCount;
  }

  componentWillUnmount () {
    window.addAdminLastMessageToList = undefined;
    window.updateConversationMessagesCount = undefined;
  }

  openConversation = () => {
    const { conversation_id } = this.props.conversation;
    if (UsersService.isAdmin()) {
      window.open(`/${appPath}/conversation/${conversation_id}`, '_blank', 'height=700, width=500');
    } else {
      this.props.selectConversationChat(conversation_id);
    }
  };

  render () {
    const { conversation, isActive } = this.props;
    const { image, title, lastMessagePreview, unread_count, job } = conversation;
    const hasNewMessages = unread_count > 0;
    let lastMessageDay;
    let lastMessageTime;

    if (lastMessagePreview) {
      const date = moment(lastMessagePreview.dc);
      lastMessageDay = date.format(dayMonthShort);
      lastMessageTime = date.format(timeFormatUi);
    }
    return (
      <section
        className={`conversations-item-wrapper ${isActive ? 'active' : ''}`}
        onClick={this.openConversation}
      >
        <div
          className='participant-photo'
          style={{ backgroundImage: `url('${job ? job.icon_url : image || defaultUserPhoto}')` }}
        />
        <div className='message-info'>
          <div className='title-wrapper'>
            <h4 className='title'>{ job ? renderDateWithTimeZone(job.start_date, dayMonthDate, job.time_zone_id) : title }</h4>
            { hasNewMessages && <div className='unread-messages-count'><strong>{unread_count}</strong></div> }
          </div>
          { job ? <h4 className='title'>{ job.location_name }</h4> : (
            <Fragment>
              { !!lastMessagePreview && (
                <p className={`message-short-text no-wrap ${hasNewMessages ? 'unread' : ''}`}>{lastMessagePreview.body}</p>
              )}
            </Fragment>
          )}
        </div>
        <div className='date-time-wrapper'>
          <p>{lastMessageDay}</p>
          <p>{lastMessageTime}</p>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/messages/ConversationsListItem.js